module.exports = __webpack_public_path__ + "img/Pic_Bg_CSXL.314bb3bc.png";